var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"topLeft","title":_vm.text}},[_c('div',{staticClass:"mixin-text-ellipse"},[_vm._v(_vm._s(_vm.text || '--'))])])}
var staticRenderFns = []

export { render, staticRenderFns }